<!-- headers -->
<header>

  <mat-toolbar color="primary">
    <mat-toolbar-row class="mat-typography">
      <img src="/assets/logo-light.png" style="height: 40px; padding-left: 40px;" alt="Teachers of Tomorrow" />
      <span class="header-spacer"></span>
      <h1>Advisor Portal</h1>
    </mat-toolbar-row>

    <mat-toolbar-row class="status-row">
      <span class="header-spacer"></span>
      @if (isAuthenticated) {
        <div class="auth-status logged-in">Logged in as {{authService.user.displayName}}</div>
      } @else {
        <div class="auth-status auth-required">Authentication required</div>
      }
    </mat-toolbar-row>

    <mat-toolbar-row class="mat-typography">

      @if (isAuthenticated) {
        <button mat-button routerLink="home">Home</button>
        <button mat-button [matMenuTriggerFor]="program">Program</button>
        <mat-menu #program="matMenu">
          @if (canUseCallAssignment) {
            <button mat-menu-item routerLink="/advisor/call-assignment">Call Assignments</button>
          }
          <button mat-menu-item routerLink="/advisor/intern-new">Add New Intern</button>
          @if (canUseTranscriptUpload) {
            <button mat-menu-item routerLink="/advisor/transcript-upload">Transcript Upload</button>
          }
          <button mat-menu-item routerLink="/advisor/transcript-processing">Transcript Processing</button>
          <button mat-menu-item routerLink="/advisor/test-approval-queue">Test Approval Queue</button>
        </mat-menu>
        <button mat-button [matMenuTriggerFor]="cert">Certifications</button>
        <mat-menu #cert="matMenu">
          <button mat-menu-item routerLink="/advisor/fbe-queue-tool">FBE Queue</button>
          <button mat-menu-item routerLink="/advisor/employment-processing">Employment Processing</button>
          <button mat-menu-item routerLink="/advisor/new-pending-certifications-tool">Pending Cert Tool</button>
          <button mat-menu-item routerLink="/advisor/standardCertTool" routerLinkActive="router-link-active">Standard Cert Tool</button>
          <button mat-menu-item routerLink="/advisor/supervisor-assignment">Field Supervisor Assignment Tool</button>
          <button mat-menu-item routerLink="/advisor/fs-obs-approval-tool">Field Supervisor Observation Approval Tool</button>
        </mat-menu>
        <button mat-button [matMenuTriggerFor]="admin">Admin</button>
        <mat-menu #admin="matMenu">
          <button mat-menu-item routerLink="/advisor/admin-district">District</button>
          <button mat-menu-item routerLink="/advisor/admin-campus">Campus</button>
          <button mat-menu-item routerLink="/advisor/test-score-import">Test Score Import</button>
          @if (canUseNotificationManager) {
            <button mat-menu-item routerLink="/advisor/notification-manager">Notification Manager</button>
          }
          @if (canUsePromotionManager) {
            <button mat-menu-item routerLink="/advisor/promotion-manager">Promotion Manager</button>
          }
          @if (canUseSponsorshipManager) {
            <button mat-menu-item routerLink="/advisor/sponsorship-manager">Sponsorship Manager</button>
            @if (showReferralCodeManager) {
              <button mat-menu-item routerLink="/advisor/referral-code-manager">Referral Code Manager</button>
            }
          }
        </mat-menu>
        <button mat-button [matMenuTriggerFor]="reports">Reports</button>
        <mat-menu #reports="matMenu">
          <button mat-menu-item routerLink="/advisor/hcl-report-tool">HCL Report</button>
          @if (canUseFSObservation) {
            <button mat-menu-item routerLink="/advisor/fs-observation-report">Field Supervisor Pay Approval</button>
          }
        </mat-menu>
        <span class="header-spacer"></span>
        <button mat-flat-button color="warn" (click)="signOut()" class="logout">LOGOUT</button>
      } @else {
        <span class="header-spacer"></span>
        <button mat-flat-button (click)="signIn()" class="sign-in-button">SIGN IN</button>
      }
    </mat-toolbar-row>
  </mat-toolbar>

</header>
